import { ArrowLeftOutlined, UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { testRunState } from '../../../../redux/testRun/testRunList.slice'
import SkeletonBasicDetails from './SkeletonBasicDetails'
import ExportReportModal from '../exportReport/ExportReportModal'
import { useState } from 'react'

const BasicDetails = ({ setOpen = () => {} }) => {
    const navigate = useNavigate()
    const { testRunDetail: testRunDetailData, testRunDetailLoading } =
        useSelector(testRunState)
    // const [isOpen, setOpen] = useState(false)

    if (testRunDetailLoading) {
        return <SkeletonBasicDetails />
    }
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <h5>{testRunDetailData?.name || ''}</h5>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 4,
                }}
            >
                <Button
                    variant="filled"
                    onClick={() => {
                        // Call parent export handler
                        setOpen(true)

                        // Or open a modal if you still want:
                        // setOpen(true)
                    }}
                    icon={<UploadOutlined />}
                    // loading={exporting}
                    // disabled={exporting}
                >
                    Export Report
                </Button>
                <Button
                    variant="filled"
                    onClick={() => {
                        navigate('/dashboard/test-run')
                    }}
                    icon={<ArrowLeftOutlined />}
                >
                    Back
                </Button>
                {/* <ArrowLeftOutlined
                    title="Back"
                    onClick={() => {
                        navigate('/dashboard/test-run')
                    }}

                /> */}
                {/* <ExportReportModal
                    isOpen={isOpen}
                    setOpen={setOpen}
                    onExport={onExport}
                /> */}
            </div>
        </div>
    )
}

export default BasicDetails
